import React from 'react';
import styles from "./Spinner.module.css";

function Spinner({ className }) {
    return (
        <div className={`${className ? className : ''} ${styles.spinner}`} role="status"/>
    );
}

export default Spinner;